export type ApplyButtonAbTestSuffix = '' | '_testA' | '_testB';

/**
 * DODASITE-25064 応募ボタンUI変更ABテスト 応募パターン判定ロジック
 * 指定されたグループ番号を応募パターン用の suffix に変換します。
 * '2' → '_testA'
 * '3' → '_testB'
 * それ以外は空文字
 * @param applyButtonChangeGroupNo グループ番号（文字列）
 * @returns '' | '_testA' | '_testB'
 */
export const getApplyButtonAbTestSuffix = (
  applyButtonChangeGroupNo: string
): ApplyButtonAbTestSuffix => {
  switch (applyButtonChangeGroupNo) {
    case '2':
      return '_testA';
    case '3':
      return '_testB';
    default:
      return '';
  }
};
